import { buildWLParam } from './whitelabel'

export function performBrowserExchangeRedirect (method, wl, hl) {
  window.axios.post('idp-id', { idp_id: method.id })
    .then(response => {
      // Keep URL construction aligned with getMethodUrl() in access.js.
      let params = '?client_id=' + method.client_id +
        '&redirect_uri=' + method.redirect_uri +
        '&response_type=' + method.response_type +
        '&scope=' + method.scopes.join(' ') +
        buildWLParam(wl)
      if (method.additional_params) {
        for (let i = 0; i < method.additional_params.length; i++) {
          params += '&' + method.additional_params[i].key + '=' + method.additional_params[i].value
        }
      }
      let href = method.url + encodeURI(params)
      if (response.data && response.data.code_challenge) {
        const url = new URL(href, window.location.origin)
        url.searchParams.set('code_challenge', response.data.code_challenge)
        url.searchParams.set('code_challenge_method', response.data.code_challenge_method)
        href = url.href
      }
      if (response.data && response.data.code_verifier) {
        sessionStorage.setItem('oauth_pkce_verifier', response.data.code_verifier)
        sessionStorage.setItem('oauth_id_token_url', response.data.id_token_url)
        sessionStorage.setItem('oauth_client_id', response.data.client_id)
        sessionStorage.setItem('oauth_redirect_uri', response.data.redirect_uri)
      }
      window.location.href = href
    })
    .catch(() => {
      window.location.href = '/error?hl=' + hl + '&error_message=Unexpected' + buildWLParam(wl)
    })
}
